export default __webpack_public_path__ + "9195ebbe9ed45ad23a0e7e16b3506c2a.webp";